

import React from 'react';
import {useTranslation} from "react-i18next";
import {Oval} from "react-loader-spinner";

function LoaderComponent(props) {

    const { t, i18n } = useTranslation()

    return (<div className={'vh-100 d-flex align-items-center col-md-6 col-12 m-auto'}>
        <Oval
            visible={true}
            height="80"
            width="80"
            color="#4fa94d"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
        />
        <h1 className={'p-3'}>
            {props.text} <small>{props.smallText}</small> <br/> Loading...
        </h1>
    </div>);
}

export default LoaderComponent;
